import { Quill } from 'react-quill'

const BlockEmbed = Quill.import('blots/block/embed');
const Embed = Quill.import('blots/embed');

class ReadOnlyBlock extends BlockEmbed {
  static blotName = 'readonlyBlock'
  static tagName = 'section'
  static className = 'readonly-block'

  static create(children) {
    const node = super.create();
    node.setAttribute('class', 'readonly-block')
    node.setAttribute('contenteditable', 'false');
    node.replaceChildren(...children)
    return node;
  }

  static value(node) {
    return node.childNodes;
  }

  // override delete to stop all deletes
  deleteAt(){}
}

class ReadOnly extends Embed {
  static blotName = 'readonly'
  static tagName = 'SPAN'
  static className = 'readonly'

  static create(node) {
    return node
  }

  static value(node) {
    return node;
  }

  // override delete to stop all deletes
  deleteAt() {}
}

export { ReadOnlyBlock, ReadOnly}